import { createContext } from "react";

export type NotificationSeverity = "success" | "error" | "warning" | "info";

export interface Notification {
  id: string;
  message: string;
  severity: NotificationSeverity;
  autoHideDuration?: number | null; // null = persistent (no auto-dismiss)
}

export interface NotificationContextValue {
  /** Show a toast notification. Returns the notification id for manual dismissal. */
  showNotification: (
    message: string,
    severity?: NotificationSeverity,
    autoHideDuration?: number | null,
  ) => string;
  /** Dismiss a specific notification by id. */
  dismissNotification: (id: string) => void;
}

export const NotificationContext =
  createContext<NotificationContextValue | null>(null);
